module.exports = __webpack_public_path__ + "static/logo-8c81a52b3139fffee5138dea2731e6f5.svg";